import type { ReactNode } from 'react';
import { fmtPct, pctDirection } from '../format';
import styles from '../style.module.scss';
import more from '../style-more.module.scss';

/** Một dòng số trong thẻ: nhãn trái, số phải, ghi chú nhỏ dưới. */
export const MetricRow = ({
  label,
  value,
  hint,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
}) => (
  <div className={more.metricRow}>
    <span className={more.metricLabel}>{label}</span>
    <span className={more.metricValue}>{value}</span>
    {hint ? <span className={more.metricHint}>{hint}</span> : null}
  </div>
);

/** "▲ +0,3%" có màu + chữ ẩn cho trình đọc màn hình. */
export const PctBadge = ({ pct }: { pct: number | null | undefined }) => {
  if (pct === null || pct === undefined) return <span className={styles.muted}>—</span>;
  const d = pctDirection(pct);
  return (
    <strong style={{ color: d.color }} className={styles.trend}>
      {d.arrow} {fmtPct(pct)}
      <span className={styles.srOnly}> ({d.word})</span>
    </strong>
  );
};
